export var DEPLOY_DATE = new Date('2025-07-10T21:27:33+0000');
